export enum calculatorNodeType {
    Question,
    Suggestion
}

export type showToastType = (message: string, color: string) => void;
